export const isMobileDevice = () => {
  if (navigator.userAgentData) {
    return navigator.userAgentData.mobile;
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileUA = /Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isIPadOS = navigator.maxTouchPoints > 1 && /Macintosh/.test(userAgent);

  return isMobileUA || isIPadOS;
};

export const getJobStatus = (statusId) => {
    if (statusId === 1) {
      return 'Active';
    }
    else if (statusId === 2) {
      return 'Inactive';
    }
    else if (statusId === 3) {
      return 'Completed';
    }
    else if (statusId === 4) {
      return 'Cancelled';
    }
    else return 'Unknown';
  };


export function convertUtcToLocal(input, opts = {}) {
  if (!input) return '—';

  let s = input;

  // If it's already a Date, use it
  if (input instanceof Date) {
    if (isNaN(input)) return '—';
    return input.toLocaleString(undefined, {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
      hour12: false, timeZoneName: 'short',
      ...opts,
    });
  }

  // Normalize strings:
  // - If it already contains Z or an offset (+hh:mm / -hh:mm), DON'T append anything.
  // - If it has no zone info, treat it as UTC by appending Z.
  if (typeof s === 'string') {
    const hasZone = /Z|[+\-]\d{2}:?\d{2}$/.test(s);
    if (!hasZone) s += 'Z';
  }

  const d = new Date(s);
  if (isNaN(d)) return '—';

  return d.toLocaleString(undefined, {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
    hour12: false, timeZoneName: 'short',
    ...opts,
  });
}